/*
    © 2022 KondaSoft.com
    https://www.kondasoft.com
*/

// import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js'

// Product options
document.querySelectorAll('.product-option').forEach(($option) => {
    $option.addEventListener('change', () => {
        const $form = $option.closest('form[action="/cart/add"]')

        const selectedOptions = []

        $form.querySelectorAll('.product-option').forEach(($option) => {
            if ($option.type === 'radio') {
                if ($option.checked) {
                    selectedOptions.push($option.value)
                }
            } else {
                selectedOptions.push($option.value)
            }
        })

        const selectedVariant = JSON.parse($form.dataset.variants).find(
            (variant) => JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
        )

        const $addToCartBtn = $form.querySelector('.btn-atc')
        const $buyItNowBtn = $form.querySelector('.btn-buy-it-now')

        if (selectedVariant) {
            // console.log(selectedVariant);

            $form.querySelector('select[name="id"]').value = selectedVariant.id

            if (selectedVariant.available) {
                $addToCartBtn.disabled = false
                $buyItNowBtn.disabled = false
                $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textAddToCart
            } else {
                $addToCartBtn.disabled = true
                $buyItNowBtn.disabled = true
                $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textSoldOut
            }

            const productPriceContainer = $form.closest('.product').querySelector('.product-price-container')

            productPriceContainer.querySelector('.product-price-final')
                .textContent = window.formatMoney(selectedVariant.price)

            const $comparePrice = productPriceContainer.querySelector('.product-price-compare')
            if ($comparePrice) {
                if (selectedVariant.compare_at_price) {
                    $comparePrice.textContent = window.formatMoney(selectedVariant.compare_at_price)
                    $comparePrice.classList.remove('d-none')
                } else {
                    $comparePrice.classList.add('d-none')
                }
            }

            window.history.replaceState({}, '', `${$form.dataset.productUrl}?variant=${selectedVariant.id}`)

            if (selectedVariant.featured_media) {
                bootstrap.Carousel.getOrCreateInstance($form.closest('.product').querySelector('.product-carousel'))
                    .to(selectedVariant.featured_media.position - 1)
            }
        } else {
            // No variant exists for this combination (e.g. "Elemento Digital" is
            // only sold with "No Temporizador"). Keep the value the customer just
            // picked and snap the OTHER options to the closest existing variant,
            // instead of dead-ending on "unavailable". Matches variant option
            // values positionally, so it also works on translated storefronts.
            const variants = JSON.parse($form.dataset.variants)
            // Map each control to its option position the same way selectedOptions
            // was built above: every <select> is its own option; radios group by
            // name. (This theme's controls carry no name attribute, so selects
            // cannot be grouped by name.)
            const $ctrls = Array.from($form.querySelectorAll('.product-option'))
            const seen = []
            const ctrlIndex = ($c) => {
                const key = $c.type === 'radio' ? 'r:' + $c.name : 's:' + ($c.id || $ctrls.indexOf($c))
                let idx = seen.indexOf(key)
                if (idx === -1) { seen.push(key); idx = seen.length - 1 }
                return idx
            }
            const indexOf = new Map($ctrls.map(($c) => [$c, ctrlIndex($c)]))
            const changedIndex = indexOf.get($option)
            const candidates = variants.filter((v) => v.options[changedIndex] === $option.value)

            if (changedIndex !== undefined && candidates.length) {
                // Prefer keeping the other currently-selected options (worth 2 each),
                // then prefer an in-stock variant (worth 1): a same-height sold-out
                // variant still beats a different-height one.
                const score = (v) => v.options.reduce((s, opt, i) =>
                    s + (i !== changedIndex && opt === selectedOptions[i] ? 2 : 0), 0) +
                    (v.available ? 1 : 0)
                candidates.sort((a, b) => score(b) - score(a))
                const target = candidates[0]

                $ctrls.forEach(($ctrl) => {
                    const idx = indexOf.get($ctrl)
                    if ($ctrl.tagName === 'SELECT') {
                        $ctrl.value = target.options[idx]
                    } else if ($ctrl.type === 'radio') {
                        $ctrl.checked = ($ctrl.value === target.options[idx])
                    }
                })
                // Only re-run the pipeline if every control actually took the
                // target value (guards against an infinite dispatch loop if a
                // value could not be applied for any reason).
                const applied = $ctrls.every(($ctrl) => {
                    const want = target.options[indexOf.get($ctrl)]
                    if ($ctrl.tagName === 'SELECT') { return $ctrl.value === want }
                    if ($ctrl.type === 'radio') { return $ctrl.checked === ($ctrl.value === want) }
                    return true
                })
                if (applied) {
                    // The combination now exists, so this does not recurse further.
                    $option.dispatchEvent(new Event('change', { bubbles: true }))
                    return
                }
            }

            $addToCartBtn.disabled = true
            $buyItNowBtn.disabled = true
            $addToCartBtn.querySelector('span').textContent = $addToCartBtn.dataset.textUnavailable
            window.history.replaceState({}, '', window.product.url)
        }
    })
})

// 'Buy it now' buttons
document.querySelectorAll('.btn-buy-it-now').forEach((btn) => {
    btn.addEventListener('click', () => {
        btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `
        const form = btn.closest('form[action="/cart/add"]')
        const variantId = form.querySelector('select[name="id"]').value
        const qty = Number(form.querySelector('input[name="quantity"]').value || 1)
        window.location.href = `/cart/${variantId}:${qty}`
    })
})

// Product Carousel - Full Screen Gallery with PhotoSwipe
// https://photoswipe.com/v5/docs/getting-started/
// const initProductCarouselSwipe = () => {
//     document.querySelectorAll('.product .product-carousel').forEach(($carousel) => {
//         const lightbox = new PhotoSwipeLightbox({
//             gallery: $carousel,
//             children: 'a',
//             pswpModule: 'https://cdn.jsdelivr.net/npm/photoswipe@5.2.2/dist/photoswipe.esm.min.js'
//         })
//         lightbox.init()
//     })
// }
// initProductCarouselSwipe()

// Product Carousel - Sticky position on scroll (only in desktop)
const initProductCarouselSitckyPos = () => {
    document.querySelectorAll('.product-carousel.sticky-carousel').forEach(($carousel) => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 20) {
                const headerHeight = document.querySelector('#shopify-section-header.sticky-top').clientHeight || 0
                $carousel.style.position = 'sticky'
                $carousel.style.top = `${headerHeight + 20}px`
            }
        })
    })
}
initProductCarouselSitckyPos()

// Delivery Info
const initDeliveryInfo = () => {
    document.querySelectorAll('.product-delivery-info').forEach(($el) => {
        const minDays = Number($el.dataset.minDays)
        const maxDays = Number($el.dataset.maxDays)

        const minDaysText = dayjs().add(minDays, 'day').format('dddd, MMM D')
        const maxDaysText = dayjs().add(maxDays, 'day').format('dddd, MMM D')

        $el.querySelector('span').insertAdjacentHTML('beforeend', `
            <b>${minDaysText}</b>
                - 
            <b>${maxDaysText}</b>
        `)
    })
}
initDeliveryInfo()

/*
    Product FBT - Set Total Price
*/
const productFbtSetTotalPrice = () => {
    let totalPrice = 0

    document.querySelectorAll('#product-fbt .form-check-input').forEach(($checkbox) => {
        if ($checkbox.checked) {
            const $select = $checkbox.closest('.product-list-item').querySelector('select[name="id"]')
            const variantPrice = Number($select.options[$select.selectedIndex].dataset.variantPrice)
            totalPrice += variantPrice
        }
    })

    document.querySelector('#product-fbt-total-price').textContent = window.formatMoney(totalPrice)

    if (totalPrice === 0) {
        document.querySelector('#btn-fbt-atc').disabled = true
    } else {
        document.querySelector('#btn-fbt-atc').disabled = false
    }
}

/*
    Product FBT - Handle variant change
*/
const productFbtVariantChange = () => {
    document.querySelectorAll('#product-fbt select[name="id"]').forEach(($select) => {
        $select.addEventListener('change', (e) => {
            productFbtSetTotalPrice()
        })
    })
}
productFbtVariantChange()

/*
    Product FBT - Handle checkbox (select product)
*/
const productFbtHandleCheckbox = () => {
    document.querySelectorAll('#product-fbt .form-check-input').forEach(($checkbox) => {
        const $imgWrapper = $checkbox.closest('.product-list-item').querySelector('.img-wrapper')

        $checkbox.addEventListener('change', (e) => {
            if ($checkbox.checked) {
                $imgWrapper.style.opacity = '1'
            } else {
                $imgWrapper.style.opacity = '0.25'
            }
            productFbtSetTotalPrice()
        })
    })
}
productFbtHandleCheckbox()

/*
    Product FBT - ATC button
*/
const productFbtAtcBtn = async () => {
    const $btn = document.querySelector('#btn-fbt-atc')

    $btn?.addEventListener('click', async (e) => {
        $btn.style.width = $btn.clientWidth + 2 + 'px'
        $btn.innerHTML = `
            <div 
                class="spinner-border spinner-border-sm" 
                role="status"
                style="width: 1rem; height: 1rem">
                <span class="visually-hidden">Loading...</span>
            </div>
        `

        const items = []

        document.querySelectorAll('#product-fbt select[name="id"]').forEach(($select) => {
            if ($select.closest('.product-list-item').querySelector('.form-check-input').checked) {
                items.push({
                    id: Number($select.value),
                    quantity: 1
                })
            }
        })

        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: items
            })
        })

        $btn.innerHTML = $btn.dataset.textAddSelected

        const event = new Event('loadOffcanvasCart')
        document.dispatchEvent(event)
    })
}
productFbtAtcBtn()

// Product list item - Handle variant change
window.onChangeProductListItemVariant = (e) => {
    const variantImageId = e.target.options[e.target.selectedIndex].dataset.variantImageId

    if (variantImageId) {
        const $carousel = e.target.closest('.product-list-item').querySelector('.carousel')

        if ($carousel) {
            let carouselItemIndex = 0

            $carousel.querySelectorAll('.carousel-item').forEach((el, index) => {
                if (el.dataset.imageId === variantImageId) {
                    carouselItemIndex = index
                }
            })

            const carousel = bootstrap.Carousel.getOrCreateInstance($carousel)
            carousel.to(carouselItemIndex)
        }
    }
}

/*
    Gallery <-> variant two-way sync.
    Sliding the product carousel selects the variant whose featured image is
    now showing, so the option dropdowns and price always match the visible
    image. (Option change -> carousel is already handled by the
    .product-option change handler at the top of this file.)
*/
const initCarouselVariantSync = () => {
    document.querySelectorAll('.product').forEach(($product) => {
        const $carousel = $product.querySelector('.product-carousel')
        const $form = $product.querySelector('form[action="/cart/add"]')
        if (!$carousel || !$form || !$form.dataset.variants) { return }

        $carousel.addEventListener('slid.bs.carousel', (e) => {
            // Carousel items map 1:1 to product.media, so slide index + 1 = media position.
            const mediaPosition = e.to + 1

            let variants
            try {
                variants = JSON.parse($form.dataset.variants)
            } catch (err) { return }

            const matches = variants.filter((v) => {
                const pos = (v.featured_media && v.featured_media.position) ||
                            (v.featured_image && v.featured_image.position)
                return pos === mediaPosition
            })

            // Image not tied to a variant (a generic / info image), or shared by
            // several variants (one valve photo is reused for every height), so it
            // cannot identify a single variant — leave the form alone. Without this
            // an option change would snap the other option back to the first variant
            // that happens to use the same image (e.g. 1200mm -> 800mm).
            if (matches.length !== 1) { return }
            const variant = matches[0]

            // Point the option controls at this variant.
            $form.querySelectorAll('.product-option').forEach(($ctrl) => {
                if ($ctrl.tagName === 'SELECT') {
                    const match = variant.options.find((opt) =>
                        Array.from($ctrl.options).some((o) => o.value === opt))
                    if (match !== undefined) { $ctrl.value = match }
                } else if ($ctrl.type === 'radio') {
                    $ctrl.checked = variant.options.includes($ctrl.value)
                }
            })

            // Reuse the existing variant-change pipeline (price, ATC button, hidden
            // id, URL). Its carousel .to() call lands on the slide we are already
            // on, so Bootstrap treats it as a no-op — no slide loop.
            const $firstOption = $form.querySelector('.product-option')
            if ($firstOption) {
                $firstOption.dispatchEvent(new Event('change', { bubbles: true }))
            }
        })
    })
}
initCarouselVariantSync()


